<div class="bg-white w-100">
  @if (businessCardLoader) {
    <div class="template-3 d-flex justify-content-center align-items-center">
      <div class="row">
        <div class="col-12 d-flex flex-column align-items-center">
          <div
            class="spinner-border text-secondary my-3 font-weight-bold d-flex align-items-center"
            role="status"
          ></div>
        </div>
      </div>
    </div>
  } @else {
    @if (businessCardData.status === 'Inactive') {
      <div class="template-3 d-flex justify-content-center align-items-center">
        <div class="row">
          <div class="col-12 d-flex flex-column align-items-center">
            <img src="../../../../assets/images/nirlatLogo.png" alt="logo" />
            <p class="h4 my-2 poppins-extrabold text-center">{{ 'inActiveBusinessCard.value' | translate }}</p>
            <p class="h6 mb-0 text-center">{{ 'activeCardMessage.value' | translate }}</p>
          </div>
        </div>
      </div>
    } @else {
      <div class="template-3">
        <div class="w-100">
          <div class="top-bar justify-content-between gap-1">
            <div class="top-bar-image d-flex justify-content-between">
              <img
                class="img-fluid logo-image"
                [src]="
                  businessCardData.logo
                    ? environment.imageUrl + businessCardData.logo
                    : '../../../../assets/images/user.png'
                "
                alt="logo"
              />
              <section class="d-flex justify-content-center flex-column">
                <p class="mb-0 ms-2 text-dark poppins-extrabold navbar-desc word-break">
                  {{ businessCardData.company }}
                </p>
                <p class="mb-0 ms-2 text-dark d-md-none d-inline-block navbar-desc word-break">
                  {{ businessCardData.slogan }}
                </p>
              </section>
            </div>
            <div class="top-bar-links w-50 d-none d-md-flex">
              <ul class="navbar-nav flex-row align-items-center w-100 justify-content-around">
                <li class="nav-item">
                  <a class="nav-link text-dark active" (click)="scroll('projectGallary')">{{
                    'projectGallery.value' | translate | titlecase
                  }}</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link text-dark active" (click)="scroll('recommendationGallary')"
                    >{{ 'customerRecommendation.value' | translate | titlecase }}
                  </a>
                </li>
              </ul>
            </div>
            <div class="top-bar-btn w-25 d-none d-md-flex">
              <a
                *ngIf="businessCardData.clientPhoneNumber"
                [href]="'https://api.whatsapp.com/send?phone=' + businessCardData.clientPhoneNumber"
                class="btn btn-warning rounded-pill w-100 poppins-extrabold border border-2 btn-shadow border-white"
                dir="ltr"
                target="_blank"
              >
                {{ 'contactMe.value' | translate | titlecase }}
                <i-feather class="icon-lg text-dark" name="message-circle"></i-feather>
              </a>
            </div>
          </div>
          <div class="cover-image d-none d-md-flex">
            <div class="block-1 d-none d-md-flex flex-column mt-4 position-relative">
              <div class="description-box">
                <p
                  class="mb-0 fs-2 text-center description-box-title poppins-extrabold fs-1 fw-1 text-center text-white"
                >
                  {{ businessCardData.slogan | titlecase }}
                </p>
                <p
                  class="mb-0 text-center description-box-descripiton poppins-light fs-6 fw-2 text-center text-white"
                  [innerHTML]="businessCardData.description"
                ></p>
              </div>
            </div>
          </div>
        </div>
        <div class="container z-2">
          <div class="profile-image" [ngClass]="businessCardData.profileImage ? 'profile-image-present' : ''">
            <img
              *ngIf="businessCardData.profileImage"
              [src]="environment.imageUrl + businessCardData.profileImage"
              class="img-fluid w-100 h-100"
              alt=""
            />
          </div>
          <div class="row mt-3 mb-3 d-flex mx-3">
            <a
              *ngIf="businessCardData.clientPhoneNumber"
              [href]="'https://api.whatsapp.com/send?phone=' + businessCardData.clientPhoneNumber"
              class="rounded-pill btn mb-2 btn-warning border border-2 gap-3 d-flex justify-content-center align-items-center border-white btn-shadow poppins-extrabold fs-6 btn-lg d-md-none"
              dir="ltr"
              target="_blank"
            >
              {{ 'contactMe.value' | translate | titlecase }}
              <i-feather class="icon-lg text-dark" name="message-circle"></i-feather>
            </a>
            <h4 class="mb-2 poppins-extrabold p-2 fs-4 slogan-box text-center">
              {{ businessCardData.businessTitle }}
            </h4>
            <div
              class="col-12 mt-3 text-start description-box-sm rtl"
              [innerHTML]="businessCardData.businessDescription"
            ></div>
          </div>
          <div
            class="block-2 mt-5 icon-container w-100"
            [ngClass]="this.linkCount <= 5 ? 'justify-content-lg-center' : 'justify-content-lg-between'"
          >
            <div class="icon-box" *ngIf="businessCardData.email">
              <a
                class="nav-link text-dark d-flex flex-column h-100 justify-content-evenly align-items-center"
                [href]="'mailto:' + businessCardData.email"
                target="_blank"
              >
                <i-feather class="icon-lg text-warning" name="mail"></i-feather>
                <p class="text fw-light icon-text mb-0">Email</p>
              </a>
            </div>
            <div class="icon-box" *ngIf="businessCardData.webUrl">
              <a
                class="nav-link text-dark d-flex flex-column h-100 justify-content-evenly align-items-center"
                [href]="businessCardData.webUrl"
                target="_blank"
              >
                <i-feather class="icon-lg text-warning" name="globe"></i-feather>
                <p class="text fw-light icon-text mb-0">website</p>
              </a>
            </div>
            <div class="icon-box" *ngIf="businessCardData.tiktokUrl">
              <a
                class="nav-link text-dark d-flex flex-column h-100 justify-content-evenly align-items-center"
                [href]="businessCardData.tiktokUrl"
                target="_blank"
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="#F7CC53" height="30" viewBox="0 0 448 512">
                  <path
                    d="M448 209.9a210.1 210.1 0 0 1 -122.8-39.3V349.4A162.6 162.6 0 1 1 185 188.3V278.2a74.6 74.6 0 1 0 52.2 71.2V0l88 0a121.2 121.2 0 0 0 1.9 22.2h0A122.2 122.2 0 0 0 381 102.4a121.4 121.4 0 0 0 67 20.1z"
                  />
                </svg>
                <p class="text fw-light icon-text mb-0">tiktok</p>
              </a>
            </div>
            <div class="icon-box" *ngIf="businessCardData.fbUrl">
              <a
                class="nav-link text-dark d-flex flex-column h-100 justify-content-evenly align-items-center"
                [href]="businessCardData.fbUrl"
                target="_blank"
              >
                <i-feather class="icon-lg text-warning" name="facebook"></i-feather>
                <p class="text fw-light icon-text mb-0">facebook</p>
              </a>
            </div>
            <div class="icon-box" *ngIf="businessCardData.instaUrl">
              <a
                class="nav-link text-dark d-flex flex-column h-100 justify-content-evenly align-items-center"
                [href]="businessCardData.instaUrl"
                target="_blank"
              >
                <i-feather class="icon-lg text-warning" name="instagram"></i-feather>
                <p class="text fw-light icon-text mb-0">instagram</p>
              </a>
            </div>
            <div class="icon-box" *ngIf="businessCardData.youtubeUrl">
              <a
                class="nav-link text-dark d-flex flex-column h-100 justify-content-evenly align-items-center"
                [href]="businessCardData.youtubeUrl"
                target="_blank"
              >
                <i-feather class="icon-lg text-warning" name="youtube"></i-feather>
                <p class="text fw-light icon-text mb-0">youtube</p>
              </a>
            </div>
            <div class="icon-box" *ngIf="businessCardData.wpNumber || businessCardData.clientPhoneNumber">
              <a
                class="nav-link text-dark d-flex flex-column h-100 justify-content-evenly align-items-center"
                [href]="getWhatsAppLink()"
                target="_blank"
              >
                <svg fill="#F7CC53" xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 0 448 512">
                  <path
                    d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
                  />
                </svg>
                <p class="text fw-light icon-text mb-0">whats app</p>
              </a>
            </div>
          </div>
          <div class="block-3 mb-4 mt-4 mt-md-5" *ngIf="businessCardData.youtubeVideoUrl">
            <div class="video-content p-2">
              <iframe
                [src]="videoId"
                title="YouTube video player"
                frameborder="0"
                class="w-100"
                style="height: 90%"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
              <p class="mb-0">{{ businessCardData.slogan | titlecase }}</p>
            </div>
          </div>
          <div class="row mt-4 mb-4 mt-md-5 block-4" id="projectGallary" *ngIf="businessCardData.workGallary.length">
            <div class="col-12 text-md-center text-start">
              <p class="fs-md-4 fs-5 poppins-extrabold">{{ 'projectGallery.value' | translate | titlecase }}</p>
            </div>

            <div class="image-container d-flex gap-3" *ngIf="!carasoul">
              <section class="image-slider" *ngFor="let item of businessCardData.workGallary">
                <img [src]="environment.imageUrl + item" class="slider-image w-100" alt="" class="img-fluid w-100" />
              </section>
            </div>

            <div class="col-12 mb-3 workGallaryCarosel" *ngIf="carasoul">
              <app-slide-generator
                [config]="workGallarySlideConfig"
                [isLoading]="isLoading"
                [imagePaths]="businessCardData.workGallary"
              ></app-slide-generator>
            </div>
          </div>
          <div class="row mb-4 mt-4 mt-md-5" *ngIf="businessCardData.recommendationGallary.length">
            <div class="col-12 text-md-center text-start">
              <p class="fs-md-4 fs-5 poppins-extrabold">{{ 'customerRecommendation.value' | translate | titlecase }}</p>
            </div>
            <div class="image-container d-flex gap-3" *ngIf="!carasoul">
              <section class="image-slider" *ngFor="let item of businessCardData.recommendationGallary">
                <img [src]="environment.imageUrl + item" class="slider-image w-100" alt="" class="img-fluid w-100" />
              </section>
            </div>
            <div class="col-12 mb-3 recommendationGallaryCarousel" *ngIf="carasoul">
              <app-slide-generator
                [config]="recommendationGallarySlideConfig"
                [imagePaths]="businessCardData.recommendationGallary"
                [isLoading]="isLoading"
              >
              </app-slide-generator>
            </div>
          </div>
          <div class="row justify-content-center align-items-center mb-3 d-none d-md-flex">
            <a
              *ngIf="businessCardData.clientPhoneNumber"
              [href]="'https://api.whatsapp.com/send?phone=' + businessCardData.clientPhoneNumber"
              class="block-4 rounded-pill btn mb-2 btn-warning border border-2 gap-3 d-flex justify-content-center align-items-center border-white btn-shadow poppins-extrabold w-50 fs-6 btn-lg"
              dir="ltr"
              target="_blank"
            >
              {{ 'contactMe.value' | translate | titlecase }}
              <i-feather class="icon-lg text-dark" name="message-circle"></i-feather>
            </a>
          </div>
          <div class="d-flex justify-content-between mt-4 gap-5 mb-2" dir="ltr">
            <section class="d-flex fs-7">
              Power By <img src="../../../../assets/images/logo/logo.png" class="img-fluid footer-img" alt="" />
            </section>
            <section class="d-flex fs-7">Copyright &copy; All rights Reserved</section>
          </div>
        </div>
      </div>
    }
  }
</div>
